module.exports = __webpack_public_path__ + "static/img/yuntu-logo.ce0ff71.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/web/footer/yuntu-logo.png
// module id = qETY
// module chunks = 1